
// const domain = 'http://47.92.193.97/api/';
// const domain = 'http://120.77.246.50/api/';
const domain = 'https://www.enweis.cn/api/';
const api = domain + 'app/';
// api = `https://${domain}admin/`;
var CONSTANT = {
  //首页接口
  INDEX: {
    CONTACT: api + 'sys_var/contact',      //联系我们
    INDEXDATA: api + 'sys_var/index',    // 首页数据
    SHOPIMG: api + 'sys_var/shop_image', //门店形象-置顶图
    TIANMAO: api + 'sys_var/tmall_image', //天猫商场-置顶图
    TIANMAOLINK: api + 'sys_var/tmall_link', //天猫商场-置顶图
  },
  //轮播图管理
  SWIPERMANAGE: {
    FINDDETAIL: api + 'banner/insert', // 确定提交
    FINDLIST: api + 'banner/detail', //获取视频
    SHOWORHIDE: api + 'banner/enable', //是否显示
    UPDATE: api + 'banner/update', //编辑
    PAGE: api + 'banner/page', // 分页
    DELETE: api + 'banner/delete', // 删除
  },
  // 依享潮流
  PRODUCTMANAGE: {
    LIST: api + 'video/list', //详情
  },
  // 依品分类
  CATEGORY: {
    DETAIL: api + 'category/detail', // 详情
    LIST: api + 'category/index', // 列表
  },
  //依品管理  依品鉴赏
  PRODUCT: {
    DETAIL: api + 'product/detail', //详情
    LIST: api + 'product/list', //列表
  },
  //艺术伊维斯
  ART: {
    FINDVAL: api + 'about/find_value', // 获取图文
  },
  //艺术插画
  ARTINSRT: {
    FINDVAL: api + 'art/find_value', // 获取图文
  },
  //内衣研究院
  RESEARCH: {
    FINDVAL: api + 'research/find_value', //获取图文详情
  },
  // vip中心接口
  VIPCENTER: {
    FINDVAL: api + 'vip/find_value', //获取图文详情
  },

  // 门店形象
  SHOP: {
    DELETE: api + 'shop/list', //列表
    PROVINCESEARCH: api + 'shop/province_by_search', //省份列表_筛选用
    IMG: api + 'shop/shop_image', //置顶图
  },

  //图片上传得到地址
  SYSTEM: {
    ADMINUPLOADFILE: domain + 'base/admin/getOSSUploadUrl',   //图片上传得到地址
  },

}
export default CONSTANT;

